import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicInput, Loader, BaasicButton } from 'core/components';

const LinkAddEditTemplate = ({
	t,
	linkAddEditViewStore: {
		form,
		loading,
		isEdit,
		cancel,
	},
}) => {
	if (loading) return <Loader />;

	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">
					{isEdit ? t('LINKSVIEW.EDITLINK') : t('LINKSVIEW.ADDNEWLINK')}
				</h3>
			</div>

			<div className="ReactModal__body">
				<BaasicInput field={form.$('description')} autoFocus />
				<BaasicInput field={form.$('url')} />
			</div>

			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="submit"
					disabled={form.$('description').error || !form.$('description').value || form.$('url').error || !form.$('url').value}
					label="SAVE"
				/>
				<BaasicButton
					className="btn btn--med btn--secondary spc--bottom--sml"
					type="button"
					onClick={cancel}
					label="CANCEL"
				/>
			</div>
		</form>
	);
};

export default defaultTemplate(LinkAddEditTemplate);
